<app-send-response [isSheet]="true" (closeSheet)="close($event)" [user]="data"></app-send-response>